<div class="user-access__wrapper">
  <div class="user-access__search">
    <input type="text" autofocus placeholder="{{ 'Search' | translate }}" [formControl]="inputSearch" />

    <ng-container *ngIf="showSearch()">
      <i class="icon icon-close_ico icon-clear_search" (click)="clearSearch()"> </i>
    </ng-container>

    <ng-container *ngIf="!showSearch()">
      <i class="icon icon-search icon-Search_ico"></i>
    </ng-container>
  </div>

  <ng-container *ngIf="(collection.items$ | push).length">
    <div class="user-access__select-all user-access__label flex-0 checkbox__label" (click)="selectAll(isSelectAllChecked)">
      <input type="checkbox" [checked]="isSelectAllChecked" />
      <span [class.user-access__check--checked]="isSelectAllChecked" class="user-access__check checkbox__check--right right-50">
      </span>

      <span class="user-access__select-all-label">Select All</span>
    </div>
  </ng-container>

  <div class="user-access__container">
    <div
      class="user-access__inner"
      infinite-scroll
      [infiniteScrollContainer]="'.user-access__inner'"
      [fromRoot]="true"
      [infiniteScrollDistance]="1"
      [infiniteScrollUpDistance]="2"
      [infiniteScrollThrottle]="100"
      (scrolled)="onScroll()">
      <div class="options-wrap" *ngIf="collection.items.length">
        <div
          *ngFor="let option of collection.items$ | push; let last = last"
          [ngClass]="{ last: last }"
          class="user-access__item">
          <div class="user-access__label checkbox__label" (click)="handleSelect(option)">
            <input type="checkbox" [checked]="_selected.has(option.id)" />
            <span
              [class.user-access__check--checked]="_selected.has(option.id)"
              class="user-access__check checkbox__check--right"></span>

            <div class="user-access__description flex-row w-100">
              <logo class="profile-avatar__picture" [url]="option?.avatars?.medium_thumb_path"></logo>

              <span class="user-name text-ellipsis">
                {{ getOptions(option, labelKey) | translate }}
              </span>
            </div>
          </div>
        </div>

        <loader [loading]="collection.loading$" [small]="true"></loader>
      </div>

      <ng-container *ngIf="!collection.items.length">
        <empty-search></empty-search>
      </ng-container>
    </div>

    <ng-container *ngIf="(collection && collection.loading) || true">
      <loader [loading]="collection.loading$" [small]="true"></loader>
    </ng-container>
  </div>
</div>
